export class TestId {
    path;
    static rootCache = new Map();
    childCache = new Map();
    constructor(path) {
        this.path = path;
    }
    static root(name) {
        const cached = TestId.rootCache.get(name);
        if (cached)
            return cached;
        const instance = new TestId([name]);
        TestId.rootCache.set(name, instance);
        return instance;
    }
    append(child) {
        const cached = this.childCache.get(child);
        if (cached)
            return cached;
        const instance = new TestId([...this.path, child]);
        this.childCache.set(child, instance);
        return instance;
    }
    toString() {
        return this.path.join('.');
    }
    get data() {
        return this.toString();
    }
}
